/* eslint-disable @typescript-eslint/no-explicit-any */

import {
  GetLeasingResponse,
  LeasingDetails,
  LeasingPost,
  LeasingRequestPayload,
  LeasingStructure,
} from "@interfaces/LeasingTypes";
import { baseApi } from "./baseApi";

const leasingApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    postLeasing: build.mutation<Response, { data: LeasingRequestPayload<LeasingDetails>; id_solicitud: string }>({
      query: ({ data, id_solicitud }) => ({
        url: `solicitudes/${id_solicitud}/leasing`,
        method: "POST",
        body: data,
      }),
    }),
    getLeasingList: build.query<LeasingStructure[], string>({
      query: (id_solicitud) => `solicitudes/${id_solicitud}/leasing?q=active:true`,
      transformResponse: (response: GetLeasingResponse) => {
        return response.data.data;
      },
    }),
    deleteVehicleById: build.mutation<void, { id_solicitud: string; vehicleId: string }>({
      query: ({ id_solicitud, vehicleId }) => ({
        url: `solicitudes/${id_solicitud}/leasing/${vehicleId}`,
        method: "DELETE",
      }),
    }),
    patchLeasing: build.mutation<
      Response,
      { data: LeasingPost<LeasingDetails>; id_solicitud: string; vehicleId: string }
    >({
      query: ({ data, id_solicitud, vehicleId }) => ({
        url: `solicitudes/${id_solicitud}/leasing/${vehicleId}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  usePostLeasingMutation,
  useLazyGetLeasingListQuery,
  useDeleteVehicleByIdMutation,
  usePatchLeasingMutation,
} = leasingApi;
